<mat-form-field appearance="outline">
  <mat-label>{{ label }}</mat-label>
  <input 
    matInput
    [placeholder]="placeholder"
    [formControl]="control"
    [errorStateMatcher]="errorStateMatcher"
    required
    [type]="hidePassword ? 'password' : 'text'"
  />
  <button matSuffix mat-icon-button type="button" (click)="hidePassword = !hidePassword" [matTooltip]="passwordTooltip()">
    <mat-icon [svgIcon]="hidePassword ? 'visibility' : 'visibility_off'"></mat-icon>
  </button>
  <mat-hint>
    <ng-content select="[bf-mat-hint]"></ng-content>
    <ng-content select="mat-hint"></ng-content>
  </mat-hint>
  <mat-error>
    <ng-content select="[bf-mat-error]"></ng-content>
    <ng-content select="mat-error"></ng-content>
  </mat-error>  
</mat-form-field>